import { StringActionDelegate } from '../../enum/string-action-delegate';

export class BaseAPIConstructorOpts {
  isProduction = true;
  environment = 'production';
  keys: Record<string, string> = {};
  onLogin: StringActionDelegate | null  = null;
}